module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-cocker-spaniel-a0f8558f.svg";